import React from "react";
import { SvgIcon } from "@mui/material";
import { COURSE_SECTION_TYPE_ID } from "../../../core/Constant";
import DocumentIcon from "./DocumentIcon";

const SectionTypeIcon = ({ contentType, sx, ...props }) => {
  if (Number(contentType) === COURSE_SECTION_TYPE_ID.VIDEO) {
    return (
      <SvgIcon sx={{ ...sx }} {...props}>
        <svg width="100%" height="100%" viewBox="0 0 100% 100%" fill="#7587E3" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M7.55556 9H14.2222C14.5278 9 14.7778 9.25 14.7778 9.55556V11.5L17 9.27778V15.3889L14.7778 13.1667V15.1111C14.7778 15.4167 14.5278 15.6667 14.2222 15.6667H7.55556C7.25 15.6667 7 15.4167 7 15.1111V9.55556C7 9.25 7.25 9 7.55556 9ZM13.6667 14.5556V10.1111H8.11111V14.5556H13.6667Z" fill="#7587E3" />
          <path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z" fill="#7587E3" />
        </svg>
      </SvgIcon>
    );
  }

  if (Number(contentType) === COURSE_SECTION_TYPE_ID.QUIZ) {
    return (
      <SvgIcon sx={{ ...sx }} {...props}>
        <svg width="100%" height="100%" viewBox="0 0 100% 100%" id="magicoon-Regular" xmlns="http://www.w3.org/2000/svg">
          <g id="question-circle-Regular">
            <path id="question-circle-Regular-2" data-name="question-circle-Regular" className="cls-1" d="M12,2.25A9.75,9.75,0,1,0,21.75,12,9.761,9.761,0,0,0,12,2.25Zm0,18A8.25,8.25,0,1,1,20.25,12,8.259,8.259,0,0,1,12,20.25ZM15.691,9.326A3.647,3.647,0,0,1,13.9,13.107c-.941.625-1.146,1-1.191,1.133a.751.751,0,0,1-.711.51.766.766,0,0,1-.239-.039.751.751,0,0,1-.471-.951,4.094,4.094,0,0,1,1.782-1.9,2.153,2.153,0,0,0,1.142-2.273A2.251,2.251,0,0,0,9.75,10a.75.75,0,0,1-1.5,0,3.751,3.751,0,0,1,7.441-.674ZM13,17a1,1,0,1,1-1-1A1,1,0,0,1,13,17Z" fill="#7587E3" />
          </g>
        </svg>
      </SvgIcon>
    );
  }

  if (Number(contentType) === COURSE_SECTION_TYPE_ID.DOCUMENT) {
    return (
      <DocumentIcon sx={sx} {...props} />
    );
  }

  return null;
};

export default SectionTypeIcon;
